import ExportedImage from 'next-image-export-optimizer';
import PPAM_RGB_OL from '../../../../../../../../../public/images/PPAM_RGB_OL.webp';
import PPXT_RGB_OL from '../../../../../../../../../public/images/PPXT_RGB_OL.webp';
import PuraPlyXT_product from '../../../../../../../../../public/images/PuraPlyXT_product.webp';
import PuraPlyAM_product from '../../../../../../../../../public/images/PuraPlyAM_product.webp';
import Affinity_RGB_OL from '../../../../../../../../../public/images/Affinity_RGB_OL.webp';
import Novachor_RGB_OL from '../../../../../../../../../public/images/Novachor_RGB_OL.webp';
import Affinity_product from '../../../../../../../../../public/images/Affinity_product.webp';
import Novachor_product from '../../../../../../../../../public/images/Novachor_product.webp';
import CYGNUS_Dual_4c_OL from '../../../../../../../../../public/images/CYGNUS_Dual_4c_OL.webp';
import product_overview_cygnus_dual from '../../../../../../../../../public/images/product-overview-cygnus-dual.webp';
import VIA_Matrix_RGB_OL from '../../../../../../../../../public/images/VIA_Matrix_RGB.webp';
import CYGNUS_Matrix_RGB_OL from '../../../../../../../../../public/images/CYGNUS_MATRIX_4c_OL.webp';
import CYGNUS_Matrix_product from '../../../../../../../../../public/images/CYGNUS-Matrix_Product.webp';
import VIA_Matrix_product from '../../../../../../../../../public/images/VIA-Matrix_Product.webp';
import PuraplyamProductsGroupImage from '../../../../../../../../../public/images/puraply-products-group.webp';
import AffinityNovachorGroupImage from '../../../../../../../../../public/images/affinity_novachor_group.webp';
import ViaCygnusProductsGroupImage from '../../../../../../../../../public/images/via_matrix_cygnus_matrix_group.webp';

const ProductsToHelpSupport = () => {
  return (
    <div className="mt-[76px] max-w-[1090px] mx-auto font-roboto-condensed">
      <div className="bg-ogn-bright-yellow px-8 py-5 bg-opacity-70">
        <h4 className="text-[22px] lg:text-[min(2.2vw,30px)] font-bold text-ogn-blue">
          Products used to help support wound healing from head-to-toe
        </h4>
      </div>
      <div className="bg-[#FFCD03] bg-opacity-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-9 px-7">
          <div>
            <div className="flex flex-col-reverse lg:flex-row lg:justify-between">
              <div className="space-y-3 mt-5">
                <ExportedImage
                  src={PPAM_RGB_OL}
                  alt="PPAM_RGB_OL"
                  width={230}
                  height={100}
                  className="object-scale-down"
                />
                <ExportedImage
                  src={PPXT_RGB_OL}
                  alt="PPXT_RGB_OL"
                  width={222}
                  height={96}
                  className="object-scale-down -ml-1"
                />
              </div>
              <div className="relative flex flex-row items-start justify-center">
                <ExportedImage
                  src={PuraplyamProductsGroupImage}
                  alt="PuraplyamProductsGroupImage"
                  width={240}
                  height={141}
                  className="-ml-16 mt-8 lg:mt-10 hidden lg:block lg:mx-0 lg:ml-auto object-scale-down"
                />
                <ExportedImage
                  src={PuraPlyXT_product}
                  alt="PuraPlyXT_product"
                  width={145}
                  height={141}
                  className="-ml-16 mt-8 lg:hidden"
                />
                <ExportedImage
                  className="absolute left-[calc(50%-15px)] lg:left-auto lg:-right-24 top-4 lg:hidden"
                  src={PuraPlyAM_product}
                  alt="PuraPlyAM_product"
                  width={141}
                  height={138}
                />
              </div>
            </div>
          </div>
          <div className="text-[18px] lg:text-[min(1.5vw,24px)] text-ogn-blue py-9 leading-relaxed max-w-[430px]">
            <div className="font-medium">
              PuraPly AM and PuraPly XT are products that help control the
              bacteria (known medically as bioburden) within the product and can
              support healing. They contain a unique combination: a natural
              collagen scaffold PLUS an advanced antimicrobial known medically
              as PHMB.*
            </div>
            <div className="text-ogn-blue block text-[16px] lg:text-[18px] mt-3">
              *PHMB, Polyhexamethylene biguanide.
            </div>
          </div>
        </div>
        <div className="border-t-[2px] border-t-[rgba(112,_112,_112,_0.33)] lg:mx-7"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-9 px-7">
          <div className="flex flex-col-reverse lg:flex-row">
            <div className="space-y-3 mt-5">
              <ExportedImage
                src={Affinity_RGB_OL}
                alt="Affinity_RGB_OL"
                width={224}
                height={96}
                className="ml-[-42px] lg:ml-0 lg:object-scale-down"
              />
              <ExportedImage
                src={Novachor_RGB_OL}
                alt="Novachor_RGB_OL"
                width={209}
                height={90}
                className="ml-[-14px] lg:ml-[12%] lg:object-scale-down"
              />
            </div>
            <div className="flex flex-col max-w-[400px] lg:max-w-[unset]">
              <ExportedImage
                src={AffinityNovachorGroupImage}
                alt="AffinityNovachorGroupImage"
                width={250}
                height={260}
                className="object-scale-down hidden lg:block"
              />
              <ExportedImage
                src={Affinity_product}
                alt="Affinity_product"
                width={247}
                height={137}
                className="lg:hidden"
              />
              <ExportedImage
                src={Novachor_product}
                alt="Novachor_product"
                width={253}
                height={138}
                className="-mt-5 ml-auto lg:ml-[unset] lg:hidden"
              />
            </div>
          </div>
          <div className="text-[18px] lg:text-[min(1.5vw,24px)] text-ogn-blue py-9 leading-relaxed max-w-[430px]">
            Affinity and Novachor act as protective barriers to support the
            healing of wounds. They are derived from placental tissue that was
            donated after the birth of a baby. Placental tissues are rich in
            natural components. Affinity and Novachor are the only fresh
            products of their kind that retain living cells, and they are the
            closest in nature to native, human tissue.
          </div>
        </div>
        <div className="border-t-[2px] border-t-[rgba(112,_112,_112,_0.33)] lg:mx-7"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-9 px-7">
          <div className="space-y-5">
            <div className="flex justify-center gap-4 mt-8 lg:hidden">
              <div className="flex gap-x-6">
                <ExportedImage
                  src={product_overview_cygnus_dual}
                  alt="product_overview_cygnus_dual"
                  width={118}
                  height={243}
                  className="mt-5 object-scale-down"
                />
                <div className="relative shrink-0">
                  <ExportedImage
                    src={CYGNUS_Matrix_product}
                    alt="CYGNUS_Matrix_product"
                    width={191}
                    height={199}
                    className="absolute -left-10 bottom-0 shrink-0"
                  />
                  <ExportedImage
                    src={VIA_Matrix_product}
                    alt="VIA_Matrix_product"
                    width={191}
                    height={199}
                    className="relative top-0 shrink-0"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-3 lg:hidden">
              <ExportedImage
                src={CYGNUS_Dual_4c_OL}
                alt="CYGNUS_Dual_4c_OL"
                width={202}
                height={51}
                className=""
              />
              <ExportedImage
                src={VIA_Matrix_RGB_OL}
                alt="VIA_Matrix_RGB_OL"
                width={184}
                height={79}
                className="-ml-[22px]"
              />
              <ExportedImage
                src={CYGNUS_Matrix_RGB_OL}
                alt="CYGNUS_Matrix_RGB_OL"
                width={225}
                height={51}
              />
            </div>
            <div className="hidden lg:grid grid-cols-2 gap-x-2">
              <div className="space-y-3 mt-5">
                <ExportedImage
                  src={VIA_Matrix_RGB_OL}
                  alt="VIA_Matrix_RGB_OL"
                  width={184}
                  height={79}
                  className="w-full ml-[max(-0.90vw,_-1rem)] max-w-[184px] object-scale-down"
                />
                <ExportedImage
                  src={CYGNUS_Matrix_RGB_OL}
                  alt="CYGNUS_Matrix_RGB_OL"
                  width={225}
                  height={51}
                  className="ml-2 w-fit object-scale-down"
                />
              </div>
              <ExportedImage
                src={ViaCygnusProductsGroupImage}
                alt="ViaCygnusProductsGroupImage"
                width={277}
                height={240}
                className="object-scale-down w-full max-w-[277px]"
              />
              <ExportedImage
                src={CYGNUS_Dual_4c_OL}
                alt="CYGNUS_Dual_4c_OL"
                width={202}
                height={51}
                className="ml-2 shrink max-w-[202px] w-full mt-5 object-scale-down"
              />
              <ExportedImage
                src={product_overview_cygnus_dual}
                alt="product_overview_cygnus_dual"
                width={118}
                height={243}
                className="mt-5 object-scale-down ml-[36px] max-w-[118px] w-full"
              />
            </div>
          </div>
          <div className=" lg:text-[min(1.5vw,24px)] text-ogn-blue pt-9 mb-12 leading-relaxed max-w-[430px]">
            VIA Matrix, CYGNUS Matrix, and CYGNUS Dual are products that act as
            protective barriers to support an optimal environment for healing.
            They are derived from placental tissue that retains natural
            components.
            <br />
            <br />
            VIA Matrix and CYGNUS Matrix are multi-layered and include all of
            the same layers that placental tissue has.
            <br />
            <br />
            CYGNUS Dual is designed to streamline the application process. It
            has 2 layers of amnion tissue that both face outward, so either side
            of the product may be applied to the wound.
          </div>
        </div>
      </div>
    </div>
  );
};

export { ProductsToHelpSupport };
